import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Form } from 'antd';
import { Popup, TextArea } from '_atoms';
import { Typography } from '_atoms/Typography';
import './style.scss';

const FORM_NAME = 'form-decline-promotion-request';

interface PopupDeclinePromotionRequestProps {
  open: boolean;
  requestTitle: string;
  loading?: boolean;
  onClose: () => void;
  onSubmit: (values: { decline_reason: string }) => void;
}

export const PopupDeclinePromotionRequest: React.FC<PopupDeclinePromotionRequestProps> = ({
  open,
  requestTitle,
  loading,
  onClose,
  onSubmit,
}) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const reason = Form.useWatch('decline_reason', form) as string | undefined;

  useEffect(() => {
    if (!open) form.resetFields();
  }, [open]);

  return (
    <Popup
      className="popup-decline-promotion-request mobile-full-size"
      open={open}
      title={t('translation:promotion_request_details.title_decline')}
      onClose={onClose}
      cancelButtonProps={{ onClick: onClose, children: t('translation:promotion_request_details.button_cancel') }}
      okButtonProps={{
        children: t('translation:promotion_request_details.button_decline'),
        form: FORM_NAME,
        htmlType: 'submit',
        loading,
        disabled: !reason?.trim(),
      }}
    >
      <Typography.Text className="popup-decline-promotion-request__text">
        {t('translation:promotion_request_details.text_decline_prefix')} <strong>{requestTitle}</strong>{' '}
        {t('translation:promotion_request_details.text_decline_suffix')}
      </Typography.Text>
      <Form name={FORM_NAME} form={form} validateTrigger="onSubmit" onFinish={onSubmit}>
        <TextArea
          label={t('translation:promotion_request_details.label_decline_reason')}
          placeholder={t('translation:promotion_request_details.ph_decline_reason')}
          maxLength={6000}
          required
          itemProps={{
            name: 'decline_reason',
            rules: [{ required: true, message: t('translation:validation.required') }],
          }}
        />
      </Form>
    </Popup>
  );
};
